import PageNotFoundAuthed from 'Modules/PageNotFound/PageNotFoundAuthed';
import { IRoutes } from '@components/3.0/Layouts/TabbedLayout/utils/constants/routes.interface';

export const notFoundRoute: IRoutes = {
  routeItem: {
    path: '*',
    element: <PageNotFoundAuthed hideTabBar />,
  },
  permissionRef: [],
  featureFlag: true,
};
